export type DigitalData = {
  environment: EnvironmentDigitalData | '';
  dl_version: string;
  application: string;
  site_version: string;
  page_info: PageInfoDigitalData;
  user: UserDigitalData;
  page_error: PageErrorDigitalData;
  process: ProcessDigitalData;
  custom: CustomDigitalData;
};

export type PageInfoDigitalData = {
  brand: string;
  page_type: string;
  country: string;
  channel: string;
  url: string;
  referrer: string;
  language: string;
};

export type UserDigitalData = {
  client_user_id: string;
  user_status: UserStatusDigitalData | '';
  client_product_type: string;
  email: string | '';
  phone: string | '';
  first_name: string | '';
  last_name: string | '';
  gender: GenderDigitalData | '';
  address: AddressDigitalData;
};

export type PageErrorDigitalData = {
  error_type: string;
  error_message: string;
};

export type ProcessDigitalData = {
  process_id: string;
  full_operation_id: string;
  registration_operation_id: string;
  transaction_id: string;
  flow_id: string;
  step_number: string;
  step_description: string;
  step_common: string;
  step_basic: string;
  step_version: string;
  progress_id: string;
  purchase_price: string;
  modality: string;
  product_name: string;
};

export type CustomDigitalData = {
  first_insurance: YesNoDigitalData | '';
  existing_car: YesNoDigitalData | '';
  insurance_start_date: string;
  hsn: string;
  tsn: string;
  brand: string;
  model: string;
  registration_year: string;
  car_engine_type: string;
  car_variant_type: string;
  car_horsepower: string;
  car_purchase_year: string;
  driven_kilometer: string;
  car_holder: string;
  zip_code: string;
  policyholder_type: string;
  policyholder_birthday: string;
  policyholder_license_date: string;
  car_user: YesNoDigitalData | '';
  car_user_birthday: string;
  car_user_licensedate: string;
  additional_car: YesNoDigitalData | '';
  customer_id: string;
  previous_insurance_brand: string;
  modality: string;
  insurance_modalities_offered: string;
  insurance_prices_offered: string;
  quoting_id: string;
  car_purpose: string;
  parking_area: string;
  flensburg_points: YesNoDigitalData | '';
  sf_class: string;
  claim_report_365_days: YesNoDigitalData | '';
  previous_insurance_duration: string;
  profession: string;
  home_ownership: string;
  phone: string;
  payment_method: string;
  payment_freq: string;
  addon_names_offered: string;
  addon_prices_offered: string;
  addon_names_selected: string;
  addon_prices_selected: string;
  customer_status: string;
  prev_insurer_canceled: YesNoDigitalData | '';
  offer_price_blocked: string | '';
  number_of_vehicles: string | '';
  voucher: string | '';
};

export type AddressDigitalData = {
  street: string | '';
  house_number: string | '';
  city: string | '';
  zip_code: string | '';
  country: string | '';
};

export const EnvironmentDigitalData = {
  PRODUCTION: 'production',
  DEVELOPMENT: 'development',
} as const;
export type EnvironmentDigitalData = (typeof EnvironmentDigitalData)[keyof typeof EnvironmentDigitalData];

export const StepBasicDigitalData = {
  QUOTING_START: 'p1:quoting start',
  PRICE_VIEW: 'p2:price view',
  PURCHASING_START: 'p3:purchasing start',
  PURCHASING_END: 'p4:purchasing end',
} as const;
export type StepBasicDigitalData = (typeof StepBasicDigitalData)[keyof typeof StepBasicDigitalData];

export const UserStatusDigitalData = {
  LOGGED: 'logged',
  NOT_LOGGED: 'not logged',
} as const;
export type UserStatusDigitalData = (typeof UserStatusDigitalData)[keyof typeof UserStatusDigitalData];

export const YesNoDigitalData = {
  YES: 'y',
  NO: 'n',
} as const;
export type YesNoDigitalData = (typeof YesNoDigitalData)[keyof typeof YesNoDigitalData];

export const CustomerStatusDigitalData = {
  NEW_CUSTOMER: 'new customer',
  EXISTING_CUSTOMER: 'existing customer',
} as const;
export type CustomerStatusDigitalData = (typeof CustomerStatusDigitalData)[keyof typeof CustomerStatusDigitalData];

export const OfferPriceBlockedReason = {
  CONTRACT_TERMINATED_BY_PREVIOUS_INSURER: 'contract terminated by previous insurer',
} as const;
export type OfferPriceBlockedReason = (typeof OfferPriceBlockedReason)[keyof typeof OfferPriceBlockedReason];

export const GenderDigitalData = {
  FEMALE: 'f',
  MALE: 'm',
  DIVERS: 'none',
};
export type GenderDigitalData = (typeof GenderDigitalData)[keyof typeof GenderDigitalData];
